export const  GET_GROUP_SESSION_REQUEST='groupSessionTutorReducer/GET_GROUP_SESSION_REQUEST';
export const  GET_GROUP_SESSION_SUCCESS='groupSessionTutorReducer/GET_GROUP_SESSION_SUCCESS';
export const  GET_GROUP_SESSION_FAILED='groupSessionTutorReducer/GET_GROUP_SESSION_FAILED';
